<template>
  <div>
    <ui-form-item :label="addressLabel" :prop="streetProp" :required="required">
      <ui-form-input
        v-model="address.street"
        :name="streetName"
      />
      <ui-form-input
        v-if="street2Visible"
        v-model="address.street2"
        :name="street2Name"
        :id="street2ID"
        placeholder="Apt, Suite, Floor, Bldg, etc"
        aria-label="Apartment, Suite, Floor, Building, Etc"
      />
    </ui-form-item>

    <div v-if="!stackCityStateZip" class="uk-child-width-1-3@m uk-margin" uk-grid>
      <div>
        <ui-form-item label="City" :prop="cityProp" :required="required">
          <ui-form-input
            v-model="address.city"
            :name="cityName"
          />
        </ui-form-item>
      </div>
      <div>
        <ui-form-item label="State" :prop="stateProp" :required="required">
          <ui-form-select
            v-model="address.state"
            :name="stateName"
            :options="stateOptions"
            input-class="inline" />
        </ui-form-item>
      </div>
      <div>
        <ui-form-item v-if="zipVisible" label="Zip" :prop="zipProp" :required="required">
          <ui-form-input
            v-model="address.zip"
            :name="zipName"
          />
        </ui-form-item>
      </div>
    </div>

    <template v-else>
      <ui-form-item label="City" :prop="cityProp" :required="required">
        <ui-form-input
          v-model="address.city"
          :name="cityName"
        />
      </ui-form-item>

      <ui-form-item label="State" :prop="stateProp" :required="required">
        <ui-form-select
          v-model="address.state"
          :name="stateName"
          :options="stateOptions"
          input-class="inline" />
      </ui-form-item>

      <ui-form-item label="Zip" :prop="zipProp" :required="required" v-if="zipVisible">
        <ui-form-input
          v-model="address.zip"
          :name="zipName"
        />
      </ui-form-item>
    </template>
  </div>
</template>

<script>
import uuid from 'uuid'
import { stateOptions } from '../../../common/helper/states'

export default {
  name: 'UiFormAddress',

  inject: {
    uiForm: {
      default: '',
    },
  },

  props: {
    required: {
      type: Boolean,
      default: undefined,
    },

    address: {
      type: Object,
      required: true,
      default() {
        return {
          street: null,
          street2: null,
          city: null,
          state: null,
          zip: null,
        }
      },
    },

    addressLabel: {
      type: String,
      default: 'Address',
    },

    propPrefix: {
      type: String,
      default: null,
    },

    namePrefix: {
      type: String,
      default: null,
    },

    nameSuffix: {
      type: String,
      default: null,
    },

    street2Visible: {
      type: Boolean,
      default: true,
    },

    zipVisible: {
      type: Boolean,
      default: true,
    },

    stackCityStateZip: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    stateOptions() {
      return stateOptions
    },

    streetProp() {
      return this.propPrefix ? `${this.propPrefix}.street` : null
    },
    street2Prop() {
      return this.propPrefix ? `${this.propPrefix}.street2` : null
    },
    cityProp() {
      return this.propPrefix ? `${this.propPrefix}.city` : null
    },
    stateProp() {
      return this.propPrefix ? `${this.propPrefix}.state` : null
    },
    zipProp() {
      return this.propPrefix ? `${this.propPrefix}.zip` : null
    },

    streetName() {
      return this.wrapName('street')
    },
    street2Name() {
      return this.wrapName('street2')
    },
    cityName() {
      return this.wrapName('city')
    },
    stateName() {
      return this.wrapName('state')
    },
    zipName() {
      return this.wrapName('zip')
    },

    street2ID() {
      return uuid.v1()
    },
  },

  methods: {
    wrapName(name) {
      if (this.namePrefix) {
        name = this.namePrefix + name
      }
      if (this.nameSuffix) {
        name = name + this.nameSuffix
      }
      return name
    },
  },
}
</script>
